import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Api from '../../../services/Api';

const CharacteristicsTypeSelector = ({
  onChanged,
  isMulti,
  selectedId,
}) => {
  const [characteristics, setCharacteristics] = useState([]);

  useEffect(() => {
    Api.get('types/characteristics?per_page=200').then((response) => {
      if (response.status === 200) {
        const mappedValues = response.data.data.map(product => ({
          label: `${product.name} [${product.code}]`,
          value: {
            id: product.id,
            code: product.code,
          },
        }));
        setCharacteristics(mappedValues);
      }
    });
  }, []);
  let selectedItem;
  if (selectedId) {
    selectedItem = characteristics.find(x => x.value.id === selectedId);
  }
  return (
    <Select
      isMulti={isMulti}
      options={characteristics}
      value={selectedItem}
      onChange={(value) => {
        if (onChanged) {
          onChanged(value);
        }
      }}
      placeholder="Select Characteristic Type"
    />
  );
};

CharacteristicsTypeSelector.propTypes = {
  onChanged: PropTypes.func,
  isMulti: PropTypes.bool,
  selectedId: PropTypes.number,
};

CharacteristicsTypeSelector.defaultProps = {
  onChanged: undefined,
  isMulti: false,
  selectedId: undefined,
};

export default CharacteristicsTypeSelector;
